export const targetBuyerIds = (targetIds, campaigns) => [...new Set(targetIds
  .map((id) => campaigns.find((campaign) => campaign.campaignId === id)?.buyerId)
  .filter((id) => id !== undefined))];

export const copySettingsErrors = ({ sourceId, targets, sections, targetBuyers = [] }) => {
  const errors = {};
  if (!sourceId) errors.sourceId = "Choose a source campaign";
  if (!targets?.length) errors.targets = "Select at least one target campaign";
  if (targetBuyers.length > 1) errors.targets = "Selected campaigns belong to different buyers";
  if (!sections?.length) errors.sections = "Choose at least one section";
  return errors;
};

export const copySettingsRequest = (targets, sections, sourceId) => ({
  data: {
    targetCampaignIds: [...new Set(targets.filter((id) => id && id !== sourceId))],
    sections: [...new Set(sections.map((section) => section.toLowerCase()))],
  },
});
